import { useContext } from "react";
import Collapse from "@mui/material/Collapse";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import NavItems from "./NavItems";
import clsx from "clsx";
import { Icon } from "components/Icon";
import { TabsMenuContext } from "contexts/TabsMenuContext";
import { SidebarMenuContext } from "contexts/SidebarMenuContext";
import { MenuType } from "contexts/TabsMenuContext/types";

interface NavGroupTypes {
  item: MenuType;
}

const NavGroup = (props: NavGroupTypes) => {
  const { item } = props;
  const tabsMenuContext = useContext(TabsMenuContext);
  const sidebarMenuContext = useContext(SidebarMenuContext);

  const handleGroupClick = () => {
    console.log("group clicked");
    console.log(item);
    console.log(tabsMenuContext);
    tabsMenuContext.onMenuGroupClick(item);
    !sidebarMenuContext.expand && sidebarMenuContext.openExpand();
  };

  return (
    <>
      <ListItem
        disablePadding
        className="mt-1 px-0 flex-col"
        onClick={handleGroupClick}
      >
        <ListItemButton
          className={clsx(
            "w-full hover:bg-gray-40 h-[42px] p-0 m-0 rounded-lg flex items-center justify-between hover:text-gray-white text-gray-160",
            item.isActive && "bg-gray-70 text-gray-white",
            sidebarMenuContext.expand && "px-4"
          )}
        >
          {sidebarMenuContext.expand ? (
            <div className="flex items-center text-inherit w-full h-full">
              <div className=" flex items-center justify-start w-full h-full">
                <Icon
                  icon={item.iconName}
                  className={clsx("!text-inherit")}
                  fontSize="1.35rem"
                />
                <span className={clsx("text-inherit font-black mr-2")}>
                  {item.title}
                </span>
              </div>
              <Icon
                className={clsx("!text-inherit")}
                icon="MdKeyboardArrowLeft"
                style={{
                  transition: "transform .25s ease-in-out",
                  ...(item.isOpen && {
                    transform: "rotate(-90deg)",
                  }),
                }}
                fontSize="1.125rem"
              />
            </div>
          ) : (
            <Icon
              icon={item.iconName}
              className={clsx("!text-inherit m-auto")}
              fontSize="1.35rem"
            />
          )}
        </ListItemButton>
        <Collapse
          unmountOnExit={false}
          component="ul"
          onClick={(e) => e.stopPropagation()}
          in={sidebarMenuContext.expand ? item.isOpen : false}
          sx={{
            pl: 0,
            width: "90%",
            alignSelf: "flex-end",
            transition: "all 0.25s ease-in-out",
          }}
        >
          <NavItems
            verticalNavItems={item.children}
            flatMenuItems={tabsMenuContext.flatMenu}
          />
        </Collapse>
      </ListItem>
    </>
  );
};

export default NavGroup;
